module.exports = __webpack_public_path__ + "static/media/casa-verde.5b2442a3.png";